import { NavLink } from "react-router-dom";

type ExchangeRateOutputProps = {
  title: string;
  rate: number;
  unit: string;
  timestamp?: string;
};

export default function ExchangeRateOutput({ title, rate, unit, timestamp }: ExchangeRateOutputProps) {
  return (
    <div className="mt-10 flex flex-wrap justify-between px-5 lg:px-12 max-w-sm md:max-w-7xl mx-auto text-gray-500 font-['Avenir']">
      <NavLink to="/dashboard" className="text-blue-600 mr-5 text-sm flex items-center">
        <code className="text-3xl mr-2">&lt;</code> <div className="mt-1">Back to dashboard</div>
      </NavLink>
      <div>
        <div className="flex flex-col items-end">
          <div className="flex flex-wrap items-center">
            <span className="text-lg font-bold inline-block mr-5">{title} Exchange Rate</span>
            <span className="text-3xl font-bold text-blue-600 font-[Avenir-Bold] mr-2">{rate.toLocaleString("en-GB", { style: "currency", currency: "EUR" })} <span className="text-blue-600 text-sm font-bold font-['Avenir']">per {unit}</span></span>
          </div>
          <div className="text-xs text-gray-900 mt-3">(Recorded at{" "}
            {new Date(timestamp).toLocaleString("en-GB", {
              dateStyle: "medium",
              timeStyle: "medium",
              hour12: true,
            })}
          )</div>
        </div>
      </div>
    </div>
  );
}
